import { AfterViewInit, Directive, Inject, OnDestroy } from "@angular/core";
import { Observable ,  ReplaySubject ,  Subscription } from "rxjs";
import { switchMap, take, takeUntil } from "rxjs/operators";
import { GenericActions } from "../../../redux/generic-actions";
import { ImmutableRedux } from "../../../redux/immutable-redux.service";
import { IGlobalMessageActions } from "../actions.interface";
import { IGlobalMessage } from "../global-message.interface";
import { FORM_POST_MESSAGE_STATE_PROP, GLOBAL_MESSAGE_STATE_PROP } from "../state-props";

@Directive({
    selector: "[form-post-message-actions]",
    exportAs: "FormPostMessageActions",
})
export class FormPostMessageActionsDirective implements IGlobalMessageActions, AfterViewInit, OnDestroy {
    readonly ngAfterViewInit$ = new ReplaySubject(1);
    readonly ngOnDestroy$ = new ReplaySubject(1);

    private state: IGlobalMessage;

    readonly state$: Observable<IGlobalMessage> = this.ngRedux
        .select(this.rootProp, this.stateProp);

    readonly stateSubscription: Subscription = this.ngAfterViewInit$.pipe(take(1),
        switchMap(() => this.state$),
        takeUntil(this.ngOnDestroy$.pipe(take(1))))
        .subscribe((state) => this.state = state);

    constructor(
        private ngRedux: ImmutableRedux<IGlobalMessage>,
        @Inject(GLOBAL_MESSAGE_STATE_PROP) public rootProp,
        @Inject(FORM_POST_MESSAGE_STATE_PROP) public stateProp,
    ) { }

    public addMessage(message: string, messageType: "success" | "error"): void {
        this.dispatch(GenericActions.VALUE_CHANGED, { message, messageType, isVisible: true });
    }

    public removeMessage(): void {
        this.dispatch(GenericActions.STATE_RESET);
    }

    public removeMessageOnRouteChange(): void {
        if (this.state && this.state.messageType === "error" && this.state.isVisible) { this.removeMessage(); }
    }

    public dispatch(actionType, payload?): void {
        this.ngRedux.dispatchFactory(actionType, this.rootProp, this.stateProp, payload);
    }

    public ngAfterViewInit() {
        this.ngAfterViewInit$.next(true);
    }

    public ngOnDestroy() {
        this.ngOnDestroy$.next(true);
    }
}
